<template>
    <div v-loading="loading">
        <hts-form-date
            v-model="filters.dateRange"
            range
            type="dateRange"
            prop="dateRange"
            :placeholder="$t('labels.fromTo')"
            class="max-w-96 max-h-96" />
        <div class="my-4">
            <h2>
                Chuyến
            </h2>

            <hts-data-table
                class="w-full mt-4"
                :headers="headers"
                :items="items || []" />
        </div>
    </div>
</template>

<script setup lang="ts">
const { $formatters } = useNuxtApp()
const { reportPage } = $store()
const loading = ref(true)

const headers = [
  {
    field: 'code',
    headerName: $t('labels.trip'),
    filter: 'agTextColumnFilter'
  },
  {
    field: 'customerName',
    headerName: $t('labels.customer'),
    filter: 'agTextColumnFilter'
  },
  {
    field: 'partnerName',
    headerName: $t('labels.fleetVehicle'),
    filter: 'agTextColumnFilter'
  },
  {
    field: 'vehicleLicensePlate',
    headerName: $t('labels.vehicle'),
    filter: 'agTextColumnFilter'
  },
  {
    field: 'status',
    headerName: $t('labels.status'),
    valueGetter: (params: any) => {
      const status = params.data.status
      if (status === -1) {
        return $t('labels.cancel')
      } else if (status === 1) {
        return 'Chưa thực hiện'
      } else if (status === 2) {
        return 'Đang thực hiện'
      } else if (status === 3) {
        return 'Hoàn thành'
      }
      return ''
    },
    filter: 'agTextColumnFilter'
  },
  {
    field: 'revenue',
    headerName: $t('labels.revenue'),
    valueGetter: (params: any) => {
      const { pricingEstimate } = params.data
      return $formatters.formatNumber(pricingEstimate?.revenue || 0)
    },
    filter: 'agNumberColumnFilter'
  },
  {
    field: 'cost',
    headerName: $t('labels.cost'),
    valueGetter: (params: any) => {
      const { pricingEstimate } = params.data
      return $formatters.formatNumber(pricingEstimate?.cost || 0)
    },
    filter: 'agNumberColumnFilter'
  },
  {
    field: 'profit',
    headerName: $t('labels.profit'),
    valueGetter: (params: any) => {
      const { pricingEstimate } = params.data
      return $formatters.formatNumber(pricingEstimate?.profit || 0)
    },
    filter: 'agNumberColumnFilter'
  },
  {
    field: 'totalJourney',
    headerName: $t('labels.journey3'),
    valueGetter: (params: any) => {
      const { totalJourney } = params.data
      if (totalJourney > 1) {
        return $t('labels.true')
      }
      return $t('labels.false')
    },
    filter: 'agTextColumnFilter'
  },
  {
    field: 'journeyNumber',
    headerName: $t('labels.journeyNumber'),
    valueGetter: (params: any) => {
      const { totalJourney } = params.data
      return $formatters.formatNumber(totalJourney || 0)
    },
    filter: 'agNumberColumnFilter'
  }
]

const items = ref<any[]>([])

const filters = computed({
  get () {
    return reportPage.filters
  },
  set (val: any) {
    reportPage.setFilters(val)
  }
})

onMounted(() => {
  getReport()
})

/** Watching */
watch(
  () => filters.value,
  (val: any) => {
    loadReport()
  },
  { deep: true }
)

/** API requests */
const getReport = () => {
  items.value = []
  $api($url.report.getTrip, { body: filters.value })
    .then((data: any) => {
      const responseData: any = data.data.value
      if (responseData?.success) {
        items.value = responseData.data
      } else {
        items.value = []
      }
      loading.value = false
    })
    .catch(() => {
      loading.value = false
    })
}

const loadReport = $lodash.debounce(getReport, 500)
</script>
